import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

function PWAInstallBottomSheet() {
    const { t } = useLanguage();

    return (
        <div
            className="offcanvas offcanvas-bottom addtohome-popup theme-offcanvas"
            tabIndex="-1"
            id="offcanvas"
        >
            <div className="offcanvas-header padding-bottom-0">
                <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </div>
            <div className="offcanvas-body small">
                <div className="app-info">
                    <img src={'/assets/images/logo/coin_64x.png'} className="img-fluid" alt="" />
                    <div className="content">
                        <h4>Xpenso</h4>
                        <Link to="#">app.xpenso.xyz</Link>
                    </div>
                </div>
                <a
                    href="#!"
                    className="btn theme-btn install-app btn-inline home-screen-btn m-0"
                    id="installapp"
                    onClick={(e) => e.preventDefault()}
                >
                    {t('installInHome')}
                </a>
            </div>
        </div>
    );
}

export default PWAInstallBottomSheet;
